// @flow

import { subscriptionPeriodTranslation } from '../Helpers';

interface Product {
  sku?: string;
  title?: string;
  item_id: string;
  item_name: string;
  category: string;
  brand: string;
  price: number;
  quantity?: number;
  list?: string;
}

interface DataLayerProduct {
  item_id: string;
  item_name: string;
  item_brand: string;
  item_category: string;
  item_category2?: string;
  item_category3?: string;
  item_category4?: string;
  item_category5?: string;
  item_variant?: string;
  item_variant_id?: string;
  item_list_name?: string;
  price: string;
  quantity?: string;
}

/**
 *
 */
export function generateProduct(product: Product): DataLayerProduct {
  const categories = product.category.split('/');

  let subscriptionSelection = null;
  if (product.subscription_period === null && product.subscription_selection === null) {
    subscriptionSelection = 'subscription not possible';
  } else if (product.subscription_period === null && product.subscription_selection) {
    subscriptionSelection = 'subscription not selected';
  } else if (product.subscription_period > 0) {
    subscriptionSelection = 'subscription selected';
  }

  const result = {
    item_id: product.item_id,
    item_name: product.item_name,
    item_brand: product.brand,
    item_variant: product.title,
    item_variant_id: product.sku,
    price: +product.price,
    quantity: product.quantity,
    item_list_name: product.list,
    item_list_id: product.variationId,
    subscription_selection: subscriptionSelection,
    subscription_period: subscriptionPeriodTranslation(product.subscription_period, product.subscription_selection) ?? null
  };

  if (product.item_variant_id_previous_add_to_cart) {
    result.item_variant_id_previous_add_to_cart = product.item_variant_id_previous_add_to_cart;
  }

  categories.forEach((category: string, index: number) => {
    result[index === 0 ? 'item_category' : `item_category${index + 1}`] = category;
  });

  return result;
}
